import type { AdminAiDownRating } from '@steado/admin-contract/ai-ratings';
import type { UserDetailTab } from '@steado/admin-contract/user-detail';

export interface RatingDestination {
  readonly userId: string;
  readonly tab?: UserDetailTab;
  readonly session?: string;
}

export function ratingDestination(row: AdminAiDownRating): RatingDestination {
  if (row.surface === 'weekly_review') return { userId: row.userId };
  return row.sessionId === null
    ? { userId: row.userId, tab: 'coach' }
    : { userId: row.userId, tab: 'coach', session: row.sessionId };
}
